import { useSelector } from "react-redux";
import { useHistory} from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react"
import { Box, Typography } from "@mui/material"
import { Button } from "../Button"
import { TypographyH3 } from "../../assets/fonts/typographyTheme"
import { useModal } from "../../hooks/useModal"
import homePageContentData from "./homePageContentData.json";
import { bannerContainerStyles, bannerDetailsStyles, bannerTypographyStyles } from "./SpikevaxBanner";

const ReservationBanner = () => {
    const { authState } = useOktaAuth() || "";
    const isAuthenticated = authState?.isAuthenticated;
    const { handleOpenModal } = useModal();
    const history = useHistory();
    const locale = useSelector((state) => state.globalStates.locale);

    const navigateOrLogin = (path) => {
        if (isAuthenticated) {
            history.push(`/${locale}/${path}`);
        } else {
            handleOpenModal(`/${locale}/${path}`);
        }
    };

    return (
        <Box sx={(bannerContainerStyles)}>
            <Box sx={bannerDetailsStyles}>
                <Box mb={homePageContentData.reservationBannerDescription? 0 : 4}>
                    <Typography sx={{...bannerTypographyStyles, fontSize:'36px'}}>{homePageContentData.reservationBannerTitle}</Typography>
                    <Typography sx={{...bannerTypographyStyles, fontSize:'24px'}}>{homePageContentData.reservationBannerDescription}</Typography>
                </Box>
                <Button
                    buttonType="mds-primary"
                    sx={{ textTransform: "none", padding: "12px 24px" }}
                    onClick={() => navigateOrLogin('reservation')}
                >
                    <TypographyH3>{homePageContentData.reservationBannerButton}</TypographyH3>
                </Button>
            </Box>
        </Box>
    )
}

export default ReservationBanner
